import React from 'react';
import { Link } from 'react-router-dom';
import { Heading, Text } from '../common/Typography';
import LandingLiveSessionMockup from './mockups/LandingLiveSessionMockup';

const LandingProductShowcase = () => (
  <section id="showcase" className="scroll-mt-24 px-4 py-12 sm:px-6 md:scroll-mt-8 lg:px-10 lg:py-16">
    <div className="mx-auto grid max-w-app-shell items-center gap-12 lg:grid-cols-2 lg:gap-16">
      <div>
        <LandingLiveSessionMockup />
      </div>
      <div>
        <p className="mb-3 text-xs font-semibold uppercase tracking-[0.18em] text-primary">
          Clubs run the night
        </p>
        <Heading level={2} className="text-3xl sm:text-4xl">
          Organisers run the session. Players just show up and play.
        </Heading>
        <Text className="mt-4 max-w-lg text-text-secondary">
          Run competitive sessions with matchmaking that balances games, wait
          times, and variety. After play, results feed into player performance so
          members can see how they are doing.
        </Text>
        <Link
          to="/signup"
          className="mt-6 inline-flex text-sm font-semibold text-primary hover:text-primary-dark underline-offset-4 hover:underline"
        >
          Start with your club
        </Link>
      </div>
    </div>
  </section>
);

export default LandingProductShowcase;
